import React, { createContext, useContext, useState, ReactNode } from 'react'

interface ModalContextType {
  isAnyModalOpen: boolean
  openModal: () => void
  closeModal: () => void
}

const ModalContext = createContext<ModalContextType | undefined>(undefined)

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openModalCount, setOpenModalCount] = useState(0)

  const openModal = () => {
    setOpenModalCount((prev) => prev + 1)
  }

  const closeModal = () => {
    setOpenModalCount((prev) => Math.max(0, prev - 1))
  }

  const value = {
    isAnyModalOpen: openModalCount > 0,
    openModal,
    closeModal,
  }

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}

export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext)
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider')
  }
  return context
}
